import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {TimeUtils} from '../../../../engine/time-utils';

@Component({
  selector: 'gg-timecode',
  templateUrl: './timecode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecodeComponent implements OnInit, OnChanges {
  @Input() current: number;
  @Input() total: number;
  @Input() isLive: boolean;

  @Output() seekToLive = new EventEmitter();

  isOnTheEdge = true;
  currentTime = '0:00';
  totalTime = '0:00';

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.currentTime = TimeUtils.secondsToTime(this.current);
    this.totalTime = this.total ? TimeUtils.secondsToTime(this.total) : '-:--';
    this.isOnTheEdge = this.current == 0 || this.total - this.current < 15;

    //console.log(this.total - this.current);
  }

  clicked() {
    //console.log('clicked');
    if (this.isLive) {
      this.seekToLive.emit();
    }
  }

}
